import { Injectable, inject } from '@angular/core';
import { ApiService } from '@app/gateway';
import { ConnectionFactory, ConnectionModel } from '../models';

@Injectable({ providedIn: 'root' })
export class ConnectionsService {
  private readonly apiService = inject(ApiService);

  public async getConnections(): Promise<ConnectionModel[]> {
    try {
      const path: string = `${ConnectionFactory.getPath()}`;
      const connections: ConnectionModel[] = await this.apiService.get<ConnectionModel[]>({ path });
      return connections;
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }
}
